export interface LoginBody {
  login: string,
  password: string,
}

export interface OtpLoginBody {
  otp: string,
}

export interface tokenData {
  jwt: string,
  rt: string,
}

export interface RedirectResponse {
  redirect_to: string,
  otp: string,
}

export type LoginResponse = tokenData | RedirectResponse;

export const isRedirectResponse = (data: LoginResponse): data is RedirectResponse => (
  'redirect_to' in data && 'otp' in data
);
